import React from 'react';

import { ThemeProvider } from '@mui/material';

import './App.css';
import theme from './theme';

import Footer from './module/footer/Footer';
import Navigation from './module/navigation/Navigation';

import About from './module/Sections/About';
import Certifications from './module/Sections/Certifications';
import ContactForm from './module/Sections/ContactForm';
import Locations from './module/Sections/Locations';
import Map from './module/Sections/Map';
import Products from './module/Sections/Products';

const App = () => {
  return (
    <div className='App'>
      <Navigation />
      <Products />
      <About />
      <Certifications />
      <Locations />
      <Map />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default function Boomerang() {
  return (
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  );
}
